import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/smart-grid-optimization/page.tsx");
